import React from "react";
import LandingHero from "./LandingHero";
import OfferingServices from "./OfferingServices";
import BestITSolutions from "./BestITSolutions";
import ClientsProjects from "./ClientsProjects";
import PortfolioLogos from "./PortfolioLogos";
import SoftwarePricing from "./SoftwarePricing";
import TeamFeedback from "./TeamFeedback";
import ContactSupport from "./ContactSupport";
const LandingHomePage = () => {
  return (
    <div>
      <LandingHero />
      <OfferingServices />
      <BestITSolutions />
      <ClientsProjects />
      <PortfolioLogos />
      <SoftwarePricing />
      <TeamFeedback />
      <ContactSupport />
    </div>
  );
};

export default LandingHomePage;
